import { FormSubmissionData } from "../forms/form-models";

export enum EnrollmentMode {
  MANDATORY = 'mandatory',
  OPTIONAL = 'optional',
  NONE = 'none'
}

export enum EnrollmentType {
  MINISTRY = 'ministry',
  SCHOOL = 'school',
  EVENT = 'event'
}

// Generic enrollment payload
export interface EnrollmentPayload<T = FormSubmissionData> {
  type: EnrollmentType;
  entityId: number;
  formData: T;
  submittedAt: Date;
}

// Enrollment API response
export interface EnrollmentResponse {
  success: boolean;
  message: string;
  enrollmentId?: string;
  error?: string;
  validationErrors?: Record<string, string>;
}


export interface Enrollment {
  type: EnrollmentMode;
  isRequired: boolean;
  capacity?: number;
  enrolled?: number;
  deadline?: string;
  cost?: {
    amount: number;
    currency: string;
  };
  formUrl?: string;
}